var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6915 10.4344V4.89186C27.6915 3.17048 26.9102 2.47461 24.9691 2.47461H20.0369C18.0958 2.47461 17.3145 3.17048 17.3145 4.89186V10.4222C17.3145 12.1558 18.0958 12.8395 20.0369 12.8395H24.9691C26.9102 12.8517 27.6915 12.1558 27.6915 10.4344Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6915 24.1693V19.2371C27.6915 17.296 26.9102 16.5146 24.9691 16.5146H20.0369C18.0958 16.5146 17.3145 17.296 17.3145 19.2371V24.1693C17.3145 26.1104 18.0958 26.8917 20.0369 26.8917H24.9691C26.9102 26.8917 27.6915 26.1104 27.6915 24.1693Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6517 10.4344V4.89186C13.6517 3.17048 12.8704 2.47461 10.9293 2.47461H5.99712C4.05599 2.47461 3.27466 3.17048 3.27466 4.89186V10.4222C3.27466 12.1558 4.05599 12.8395 5.99712 12.8395H10.9293C12.8704 12.8517 13.6517 12.1558 13.6517 10.4344Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6517 24.1693V19.2371C13.6517 17.296 12.8704 16.5146 10.9293 16.5146H5.99712C4.05599 16.5146 3.27466 17.296 3.27466 19.2371V24.1693C3.27466 26.1104 4.05599 26.8917 5.99712 26.8917H10.9293C12.8704 26.8917 13.6517 26.1104 13.6517 24.1693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardlight);
export default __webpack_public_path__ + "static/media/dashboardlight.458daf60c2de9a84150bcee4fb6ae95d.svg";
export { ForwardRef as ReactComponent };